import { render, staticRenderFns } from "./DocumentTargetPicker.vue?vue&type=template&id=f2fad748&scoped=true"
import script from "./DocumentTargetPicker.vue?vue&type=script&lang=js"
export * from "./DocumentTargetPicker.vue?vue&type=script&lang=js"
import style0 from "./DocumentTargetPicker.vue?vue&type=style&index=0&id=f2fad748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fad748",
  null
  
)

export default component.exports